import { render, staticRenderFns } from "./HKReportHistorgramChart.vue?vue&type=template&id=e20f2f00&scoped=true"
import script from "./HKReportHistorgramChart.vue?vue&type=script&lang=js"
export * from "./HKReportHistorgramChart.vue?vue&type=script&lang=js"
import style1 from "./HKReportHistorgramChart.vue?vue&type=style&index=1&id=e20f2f00&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e20f2f00",
  null
  
)

export default component.exports